import Chart1 from "../assets/img/chart1.png";
import Chart2 from "../assets/img/chart2.png";
import Chart3 from "../assets/img/chart3.png";

import USAFlag from "../assets/img/USA-flag.png";
import EUFlag from "../assets/img/eu-flag.png";
import {
  AccountSummary,
  Task,
  History,
  Quotes,
  PartnerCompanies,
  Financing,
  Messages,
  Drafts,
  WalletCard,
  ActionBanner,
  GreetUser,
} from "../components/Dashboard";

import AddIcon from "../components/Icons/AddIcon";
import XFlowVbanCard from "../components/Dashboard/XFlowVbanCard";
import ReceivablePieChart from "../components/Dashboard/RecievablePieChart";
import { FinancingCard } from "../components/Dashboard/FinancingCard";
import ServicesDetailsTab from "../components/Dashboard/ServicesDetailsTab";
import SideDetails from "../components/Dashboard/SideDetails";
import Mapwrap from "../assets/img/Map-wrap.png";
import { options } from "../components/Dashboard/AccountSummary";

import Dropdown from "../components/DropDown";
import { createContext, useContext, useRef, useState } from "react";
import {
  DashCardExpandContextProvider,
  useCardExpandContext,
} from "../context/DashCardExpandContext";

const financingData = [
  { name: "Karur Fabrics", amount: "800,000 USD" },
  { name: "Sharon Impex", amount: "2.05 M USD" },
  { name: "Sharon Impex", amount: "520,000 USD" },
  { name: "Another Corp", amount: "1.2 M USD" },
];

const Dashboard = () => {
  return (
    <DashCardExpandContextProvider>
      <section className="relative grid grid-cols-1 xl:grid-cols-[minmax(0,1fr)_340px] gap-6">
        {/* <ActionBanner /> */}
        {/* <GreetUser /> */}

        <section className="grid grid-cols-2 gap-6">
          {/* <div className="card">
          <h2 className="font-semibold text-lg mb-2">Total Amount</h2>

          <div className="flex justify-between items-center">
            <div>
              <p>
                <span className="font-bold text-3xl">1257.00</span>{" "}
                <span className="font-medium text-xs text-[#9C9FAD]">
                  / This Month
                </span>
              </p>
              <small className="text-[#9C9FAD]">1050.00.last month</small>
            </div>

            <div>
              <img src={Chart1} alt="chart" />
            </div>
          </div>
        </div> */}

          {/* <div className="flip-card card">
          <div className="flip-card-inner relative w-full h-full">
            <div className="flip-card-front">
              <div className="flex items-center justify-between mb-2">
                <h2 className="font-semibold text-lg">USD - Account</h2>
                <img src={USAFlag} alt="usa flag" />
              </div>

              <div className="flex justify-between items-center">
                <div>
                  <p>
                    <span className="font-bold text-3xl">557.00</span>{" "}
                    <span className="font-medium text-xs text-[#9C9FAD]">
                      / This Month
                    </span>
                  </p>
                  <small className="text-[#9C9FAD]">100.00.last month</small>
                </div>

                <div>
                  <img src={Chart2} alt="chart" />
                </div>
              </div>
            </div>

            <div className="flip-card-back">
              <h3 className="font-medium">Account Details:</h3>
              <div>
                <p className="text-[12px] flex justify-between">
                  <span>Account No.:</span>{" "}
                  <span className="text-[#6C6868]">01299319329201</span>
                </p>
                <p className="text-[12px] flex justify-between">
                  <span>IBAN Account:</span>{" "}
                  <span className="text-[#6C6868]">PADG01299319329201</span>
                </p>
                <p className="text-[12px] flex justify-between">
                  <span>Routing No:</span>{" "}
                  <span className="text-[#6C6868]">12997</span>
                </p>
                <p className="text-[12px] flex justify-between">
                  <span>Bank Address:</span>
                  <span className="text-[#6C6868]">
                    Lorem Ipsum is the dummy dummy
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div> */}

          {/* <WalletCard /> */}
          {/* <XFlowVbanCard /> */}

          {/* <div
            id="euro-account"
            className="card h-[146px] !bg-custom-dark-blue-new text-white !rounded-2xl !border !border-blue-100/70"
          >
            <div className="flex items-center justify-between mb-2">
              <h2 className="font-semibold text-lg">EURO - Account</h2>
              <img src={EUFlag} alt="eu flag" />
            </div>

            <div className="flex justify-between items-center">
              <div>
                <p>
                  <span className="font-bold text-3xl">0.00</span>{" "}
                  <span className="font-medium text-xs text-white">
                    / This Month
                  </span>
                </p>
                <small className="text-white">650.00.last month</small>
              </div>

              <div>
                <img src={Chart3} alt="chart" />
              </div>
            </div>
          </div> */}

          {/* <div className="card flex flex-col justify-center items-center gap-2 ">
          <button className="flex items-center gap-2 font-semibold text-[#6F6D6D]">
            <AddIcon className="size-9" />
            <span>Add New Currency</span>
          </button>
          <p className="text-sm text-[#9C9FAD]">
            Add a new currency to your account
          </p>
        </div> */}

          {/* <AccountSummary /> */}
          {/* <Task /> */}

          <GroupServices />
        </section>

        <SideDetails />

        <PartnerCompanies />

        {/* <div className="card mt-6 shadow-sm">
        <div className="flex items-center justify-between border-b pb-2">
          <h2 className="text-[#030303] font-semibold text-xl">
            Partner Companies
          </h2>

          <div className="w-[100px]">
            <Dropdown label="" options={options} />
          </div>
        </div>
        <img src={Mapwrap} alt="map" />
      </div> */}
        {/* <section className="grid grid-cols-2 gap-6 mt-6">
        <Financing />
        <Messages />
      </section> */}

        {/* <DashboardTour /> */}

        {/* <div
        className="w-[500px] h-[500px] bg-green-600"
        style={{
          clipPath:
            'path("M 10,70 A 10,10,0,0,1 20,40 L 70,40 A 10,10,0,0,0 80,30 L 80,10 A 10,10,0,0,1 90,0 L 140,0 A 10,10,0,0,1 150,10 L 150,190 A 10,10,0,0,1 140,200 L 10,200 A 10,10,0,0,1 0,190 L 0,40 0,50 Z")',
        }}
      ></div> */}

        {/* White background on the left third */}
        {/* <div className="absolute top-0 right-0 h-full w-[350px] bg-white -z-10" /> */}
      </section>
    </DashCardExpandContextProvider>
  );
};

export default Dashboard;

function GroupServices() {
  const { leftColRef, rightColRef } = useCardExpandContext();

  return (
    <div className="col-span-2 flex flex-col lg:flex-row gap-6 w-full min-w-0">
      <div
        ref={leftColRef}
        className="flex flex-col md:flex-row lg:flex-col gap-6 w-full lg:w-[300px] transition-all duration-500 overflow-hidden opacity-100"
      >
        <ReceivablePieChart />

        <FinancingCard data={financingData} />
      </div>

      <div ref={rightColRef} className="flex-1 transition-all duration-500">
        <ServicesDetailsTab />
      </div>
    </div>
  );
}
